// The step-kinds carousel: native scroll-snap does the work; arrows and dots steer it.
document.querySelectorAll("[data-strip]").forEach((wrap) => {
  const track = wrap.querySelector("[data-strip-track]")
  const items = [...wrap.querySelectorAll("[data-strip-item]")]
  const dots = [...wrap.querySelectorAll("[data-strip-dot]")]
  const prev = wrap.querySelector("[data-strip-prev]")
  const next = wrap.querySelector("[data-strip-next]")
  if (!track || items.length === 0) return
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  const current = () => {
    const x = track.scrollLeft
    let best = 0
    items.forEach((el, k) => { if (Math.abs(el.offsetLeft - x) < Math.abs(items[best].offsetLeft - x)) best = k })
    return best
  }
  // Own animation: browser smooth-scroll is unreliable inside mandatory snap containers.
  let timer = 0
  const go = (k) => {
    k = Math.max(0, Math.min(items.length - 1, k))
    const target = Math.min(items[k].offsetLeft - 28, track.scrollWidth - track.clientWidth)
    clearTimeout(timer)
    if (reduced) {
      track.scrollLeft = target
      return
    }
    const from = track.scrollLeft
    const t0 = performance.now()
    const dur = 380
    track.style.scrollSnapType = "none"
    // setTimeout rather than rAF: keeps working in background/automation tabs where rAF pauses
    const step = () => {
      const p = Math.min(1, (performance.now() - t0) / dur)
      const e = 1 - Math.pow(1 - p, 3)
      track.scrollLeft = from + (target - from) * e
      if (p < 1) timer = setTimeout(step, 16)
      else {
        track.scrollLeft = target
        track.style.scrollSnapType = ""
        sync()
      }
    }
    step()
  }
  const sync = () => {
    const k = current()
    dots.forEach((d, i) => (i === k ? d.setAttribute("aria-current", "true") : d.removeAttribute("aria-current")))
    const maxLeft = track.scrollWidth - track.clientWidth - 8
    if (prev) prev.disabled = track.scrollLeft <= 8
    if (next) next.disabled = track.scrollLeft >= maxLeft
  }
  prev?.addEventListener("click", () => go(current() - 1))
  next?.addEventListener("click", () => go(current() + 1))
  dots.forEach((d, i) => d.addEventListener("click", () => go(i)))
  track.addEventListener("scroll", () => requestAnimationFrame(sync), { passive: true })
  window.addEventListener("resize", sync)
  sync()
})
